import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-salvar-busca',
  standalone: true,
  templateUrl: './modal-salvar-busca.component.html',
  styleUrls: ['./modal-salvar-busca.component.scss'],
})
export class ModalSalvarBuscaComponent implements OnInit {
  public nomeBusca?: string;
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService
  ) {}

  ngOnInit() {}

  onClose(): void {
    this.bsModalRef.hide();
  }
}
